/* eslint-env node, browser */
"use strict";

module.exports = require("./Combokeys");
